import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { PathParams, RoutingPath } from '../../../../../routes/routing-path';
import { useAppSelector } from '../../../../../app/hooks';
import './print-sidebar.scss';
import iconReturn from '../../../../../assets/img/icon/return.svg';
import { dialogActions } from '../../../../dialog/slice/dialog-slice';
import { SelectFormDesignation } from '../../../../dialog/unique/select-form-designation';
import * as lodash from 'lodash';
import { apiActions } from '../../../../../slices/api-slice';
import { useParams } from 'react-router-dom';
import { ResponseBase } from '../../../../../api/response-base';
import { orderLockActions } from '../../../../../slices/lock-order-slice';
import { orderPreparationActions } from '../../../../../slices/order-preparation-slice';
import {
  ApiShopOrderStatusListGet,
  ShopOrderListGetResponseStatus, StatusList,
} from '../../../../../api/front/shop-order/api-shop-order-list';
import warningIcon from '../../../../../assets/img/icon/warning_icon.svg';
import { Input } from '../../../../ui/input/input';
import { Radiobutton } from '../../../../ui/input/radiobutton';
import { Select } from '../../../../ui/select/select';
import { Button } from '../../../../ui/button/button';
import { ColorIcon } from '../../../../ui/color-icon/color-icon';
import { TextArea } from '../../../../ui/textarea/textarea';
import { LoadingPopup } from '../../../../ui/loading/loading-popup';
import { ApiPrintMetaShopOrderPost, MetaPrintShopOrderGetResponse } from '../../../../../api/sift/front/api-print-meta-shop-order';
import { printActions } from '../../../../../slices/sift/print-slice';
import { usePrintOrder } from '../../hooks/use-print-order';
import { usePrintDelivery } from '../hooks/use-print-delivery';
import { RecordData } from '../../../../../utilities/utility.type';
import { hasRecordValue } from '../../../../../utilities/has-record-value';
import { usePrintStatus } from '../../hooks/use-print-status';
import { webPagePath } from '../../../../../models/web-page-path';
import { NewPage } from '../../../../../utilities/new-page';
type Props = {
  memo: Partial<RecordData<string>>,
  resetItemMemo: () => void,
  onGetMeta: (param?: MetaPrintShopOrderGetResponse) => void,
  ordered?: boolean,
}
export const PrintSideBar = (props: Props) => {
  const {
    memo: itemMemo,
    resetItemMemo,
    onGetMeta,
    ordered,
  } = props;
  // - Hooks -
  const dispatch = useDispatch();
  const { kijshopCd, shopOrderId } = useParams<PathParams>();

  const {
    currentMeta,
    currentData,
    deliveryStore: _deliveryStore,
    customerOrderId,
    note,
    masterShop,
    masterShopSystemData,
    orderedList,
    updatingCustomerName,
    registeringCustomerName,
  } = useAppSelector((state) => ({
    customerOrderId: state.common.customerOrderId,
    currentMeta: state.print.printShopOrderMeta[shopOrderId],
    note: state.orderPreparation.orderData?.note,
    deliveryStore: state.orderPreparation.orderData?.lastName || '',
    xml: state.xml[shopOrderId],
    masterShopList: state.common.data.masterShop?.lnwMasterShop.shop?.[0].shopData,
    masterShop: state.common.data.masterShop?.lnwMasterShop.system?.[0].systemData,
    orderingShopId: state.common.orderingShopId,
    deliveryTypeInitValue: state.storage.data.deliveryType,
    // isProxyMode: Boolean(state.systemConfig.metaData.surrogateOrder || state.xml[shopOrderId]?.info.metaModel.dpNumber),
    isProxyMode: Boolean(state.xml[shopOrderId]?.info.metaModel.dpNumber),
    masterShopSystemData: state.common.data.masterShop?.lnwMasterShop?.system?.[0]?.systemData || [],
    orderedList: state.common.orderedList?.order || [],
    updatingCustomerName: state.orderPreparation.updatingCustomerName,
    registeringCustomerName: state.orderPreparation.registeringCustomerName,
    updatingDesignation: state.orderPreparation.updatingDesignation,
    imageLessOrder: state.orderPreparation.imageLessOrder,
    orderData: state.orderPreparation.orderData,
    currentData: state.print.printShopOrderData[shopOrderId],
  }), lodash.isEqual);

  const {
    getData,
    getMetaData,
  } = usePrintOrder();
  const {
    deliveryStore,
    deliveryStoreList,
    deliveryType,
    changeDeliveryType,
    handlerClickDeliveryStoreRegister,
    handlerClickFormDesignation,
    handlerChangeDeliveryStore,
  } = usePrintDelivery();
  const {
    statusName,
  } = usePrintStatus();
  // - Ref -
  // -- お客様氏名 --
  const customerNameRef = useRef<HTMLInputElement>(null);
  // - State -
  // -- お客様氏名 --
  const [customerName, setCustomerName] = useState('');
  // -- disable用背景 --
  const [disableBg, setDisableBg] = useState(false);
  const [redBox, setRedBox] = useState('');
  // -- 配送店舗 --
  // const [deliveryStore, setDeliveryStore] = useState(_deliveryStore || '');
  // const [deliveryStoreList, setDeliveryStoreList] = useState<{ value: string, label: string }[]>([]);
  // -- メモ --
  const [memo, setMemo] = useState('');
  const [orderMemo, setOrderMemo] = useState('');
  const [checkOrderMemo, setCheckOrderMemo] = useState(false);
  const [checkItemMemo, setCheckItemMemo] = useState(false);
  // 個別配送対応店舗はtrue
  const [showCheckbox, setShowCheckbox] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [orderedStatusName, setOrderedStatusName] = useState('');
  const isLaboOrderRetry = useRef(false);
  // -- 更新待機用 --
  // const [updatingName, setUpdatingName] = useState(false);
  // const [updating, setUpdating] = useState(false);

  const loadError = useCallback(() => {
    dispatch(dialogActions.pushMessage({
      title: 'エラー',
      message: [
        'すでに削除済みのオーダーのため編集できません。',
        '「OK」をクリックすると 注文一覧に戻ります。',
      ],
      buttons: [{
        label: 'OK',
        callback: () => {
          dispatch(dialogActions.popAll());
          dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
        },
      }],
    }));
  }, [kijshopCd]);
  // - Callback -
  // -- 注文一覧に戻るボタン --
  const handlerClickBackOrderList = useCallback(() => {
    if (!currentMeta || customerName && customerName !== 'null') {
      // if (updatingCustomerName) {
      //   dispatch(orderPreparationActions.setRegisteringCustomerName(true));
      //   // setUpdating(true);
      // } else {
        // }
      dispatch(push(RoutingPath.cnv.print({ kijshopCd })));
    } else {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'お客様名が入力されていません。',
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
              setRedBox('redBox');
            },
          },
        ],
      }));
    }
  }, [customerName, updatingCustomerName]);
  // -- お客様氏名 --
  const handlerChangeCustomerName = useCallback((v) => {
    setCustomerName(v);
  }, [updatingCustomerName]);
  // -- お客様氏名のフォーカスが外れたとき --
  const handlerBlurCustomerName = useCallback((v) => {
    if (!currentMeta) {
      return
    };
    dispatch(orderLockActions.check(
      kijshopCd, shopOrderId,
      {
        yes: async() => {
          setRedBox('');
          const metaData = await getMetaData();
          dispatch(apiActions.run(
            new ApiPrintMetaShopOrderPost({
              ...metaData,
              lastName: v,
            }),
            {
              onSuccess: () => {
                getMetaData();
                dispatch(orderPreparationActions.setUpdatingCustomerName(false));
              },
              onError: () => {
                dispatch(orderPreparationActions.setUpdatingCustomerName(false));
              }
            }
          ))
        },
        no: () => {

        },
      },
    ));
  }, [
    kijshopCd,
    shopOrderId,
    dispatch,
    currentMeta,
    getMetaData
  ]);
  const handlerChangeOrderMemo = useCallback((v) => {
    setOrderMemo(v);
  }, [customerOrderId]);
  const handlerBlurOrderMemo = useCallback((v: string) => {
    if (!currentMeta) {
      return
    };
    dispatch(orderLockActions.check(
      kijshopCd, shopOrderId,
      {
        yes: async() => {
          setRedBox('');
          const metaData = await getMetaData();
          dispatch(apiActions.run(
            new ApiPrintMetaShopOrderPost({
              ...metaData,
              note: v.replaceAll('\r', ''),
            })
          ))
        },
        no: () => {

        },
      },
    ));
  }, [memo, customerOrderId, note, currentMeta]);
  // メモ情報変更
  const removeMemoMessage = useCallback((callback: () => void) => {
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message: ['編集中のコメントは破棄されます。よろしいですか？'],
      buttons: [
        { label: 'キャンセル', callback: () => dispatch(dialogActions.pop()) },
        { label: 'OK', callback: () => {
          dispatch(dialogActions.pop());
          callback();
        } },
      ],
    }));
  }, [dispatch]);
  const handlerChangeCheckOrderMemo = useCallback((v: boolean) => {
    if (v === checkOrderMemo) return;
    if (!v) {
      removeMemoMessage(async() => {
        if (currentData?.meta) {
          if (!currentData.meta.meta) {
            currentData.meta.meta = {};
          }
          currentData.meta.meta.checkOrderMemo = false;
          setCheckOrderMemo(false);
          dispatch(printActions.shopOrder({ kijshopCd, shopOrderId }).update(
            currentData.meta,
          ));
          const metaData = await getMetaData();
          dispatch(apiActions.run(
            new ApiPrintMetaShopOrderPost({
              ...metaData,
              note: '',
            })
          ))

        }
      });
    } else {
      if (currentData?.meta) {
        if (!currentData.meta.meta) {
          currentData.meta.meta = {};
        }
        currentData.meta.meta.checkOrderMemo = true;
        setCheckOrderMemo(true);
        dispatch(printActions.shopOrder({ kijshopCd, shopOrderId }).update(
          currentData.meta,
        ));
      }
    }

  }, [
    dispatch,
    kijshopCd, shopOrderId,
    getMetaData,
    removeMemoMessage,
    currentData,
    checkOrderMemo,
  ]);
  const handlerChangeCustomerMemo = useCallback((v: string) => {
    setMemo(v);
  }, []);
  const handlerBlurCustomerMemo = useCallback(() => {
    if (currentData) {
      if (!currentData.meta.meta) {
        currentData.meta.meta = {};
      }
      currentData.meta.meta.customerMemo = memo;
      dispatch(printActions.shopOrder({ kijshopCd, shopOrderId }).update(
        currentData.meta,
      ));
    }
  }, [
    memo,
    dispatch,
    kijshopCd, shopOrderId,
    currentData,
  ]);
  const handlerClickCombinedShippingLink = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    NewPage.tab(webPagePath.combinedShippingNotAllowed);
  }, []);
  // - Effect -
  useEffect(() => {
    if (masterShopSystemData.find((v) => v.$.systemID === 'customerDelivery')) {
      setShowButton(true);
    }
  }, [masterShopSystemData]);
  // -- お客様氏名の入力が空のときフォーカス --
  useEffect(() => {
    if (customerName === '' && customerNameRef.current) {
      // customerNameRef.current.focus();
      customerNameRef.current.onfocus = () => {
        dispatch(orderPreparationActions.setUpdatingCustomerName(true));
      };
    }
  }, [customerName]);

  // ラジオボタンを表示する店舗一覧。
  useEffect(() => {
    if (masterShop) {
      if (masterShop.find((v) => v.$.systemID === 'customerDelivery')) {
        setShowCheckbox(true);
      }
    }
  }, [masterShop]);
  // メタ情報取得
  useEffect(() => {
    getMetaData().then((res) => {
      dispatch(printActions.setShopOrderMeta(res));
      setCustomerName(res.lastName ?? '');
      if (!res.lastName) {
        customerNameRef?.current?.focus();
      }
      if (`${res.note}` !== 'null') {
        setOrderMemo(res.note.replaceAll('\r', '') || '');
      }
      onGetMeta(res);
    }).catch(() => {
      onGetMeta();
    })
  }, [
    shopOrderId,
  ]);

  // メモ情報取得
  useEffect(() => {
    if (!currentData) return;
    setCheckItemMemo(!!currentData.meta.meta?.checkItemMemo);
    setCheckOrderMemo(!!currentData.meta.meta?.checkOrderMemo);
    setMemo(currentData.meta?.meta?.customerMemo ?? '');
  }, [currentData]);
  const _statusList = ['注文作成中', '注文作成済', 'レイアウト中', 'ラボ発注可'];

  const [allList, setAllList] = useState<StatusList>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!orderedList) return;
    const setStatus = (list: StatusList) => {
      const data = orderedList.find((v) => v.shopOrderId === shopOrderId);
      if (data) {
        setOrderedStatusName(data.orderStatusName);
      } else {
        const data2 = list.find((v) => v.shopOrderId === shopOrderId);
        if (data2) {
          setOrderedStatusName(data2.status);
        }
      }
    };
    if (allList.length === 0 && !loading) {
      setLoading(true);
      dispatch(apiActions.run(
        new ApiShopOrderStatusListGet(kijshopCd),
        {
          onSuccess: (res: ResponseBase<ShopOrderListGetResponseStatus>) => {
            setLoading(false);
            setAllList(res.body.data?.statusList || []);
            setStatus(res.body.data?.statusList || []);
          },
        },
      ));
    } else {
      setStatus(allList);
    }
  }, [shopOrderId, orderedList, allList]);

  useEffect(() => {
    if (registeringCustomerName && !updatingCustomerName) {
      dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
      dispatch(orderPreparationActions.setRegisteringCustomerName(false));
    }
    return () => {
      dispatch(orderPreparationActions.setRegisteringCustomerName(false));
    };
  }, [updatingCustomerName]);
  useEffect(() => {
    if (registeringCustomerName && !customerName) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'お客様名が入力されていません。',
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
              setRedBox('redBox');
            },
          },
        ],
      }));
      dispatch(orderPreparationActions.setRegisteringCustomerName(false));
    }
  }, [registeringCustomerName]);

  const ordering = Boolean(false);

  return (
    <>
      <div className="print_sidebar">
        <div
          className="print_sidebar__return"
          onClick={handlerClickBackOrderList}
        >
          <img
            src={iconReturn}
            alt=""
          />
          <div>注文一覧に戻る</div>
        </div>
        <div className="print_sidebar__contents">
          <div className="print_sidebar__contents__title">
            注文概要
          </div>
          <div className="print_sidebar__contents__item">
            <div className="item_label">
              作成日時
            </div>
            <div className="item_body">
              {currentMeta?.createDate?.slice(0, 16)}
            </div>
          </div>

          <div className="print_sidebar__contents__item">
            <div className="item_label">
              注文番号
            </div>
            <div className="item_body">
              {shopOrderId}
            </div>
          </div>

          <div className={`print_sidebar__contents__item item_customer${customerName === '' ? ' no_name' : ''}`}>
            <div className="item_label">
              お客様氏名
            </div>
            <div className={`item_body ${redBox}`}>
              <Input
                value={customerName}
                onChange={(e) => handlerChangeCustomerName(e.target.value)}
                onBlur={(e) => handlerBlurCustomerName(e.target.value)}
                ref={customerNameRef}
                maxLength={30}
                disabled={ordered}
              />様
            </div>
          </div>

          <div className="print_sidebar__contents__item item_delivery">
            <div className="item_label">
              配送店舗
            </div>
            <div className="item_body">
              {showCheckbox ? (
                <div className="radio_buttons_box">
                  <Radiobutton
                    value="store"
                    onChange={() => changeDeliveryType('store')}
                    checkState={deliveryType}
                    label="店舗配送"
                    disabled={ordered}
                  />
                  <Radiobutton
                    value="private"
                    // onChange={(e) => handlerChangeDeliveryType(e.target.value)}
                    onChange={() => changeDeliveryType('private')}
                    checkState={deliveryType}
                    label="個別配送"
                    disabled={ordered}
                  />
                </div>
              ) : (<></>)}
              {deliveryType === 'store' ? (
                <div className="item_body__type_store">
                  <Select
                    value={deliveryStore}
                    list={deliveryStoreList}
                    onChange={(e) => handlerChangeDeliveryStore(e.target.value)}
                    disabled={ordered}
                  />
                  {
                    showButton && (masterShopSystemData.find((v) => v.$.systemID === 'shipmentFormImport')) ? (
                      <Button
                        label="発送帳票指定"
                        onClick={handlerClickFormDesignation}
                        disabled={ordered}
                      />
                    ) : (<></>)
                  }
                </div>
              ) : (<></>)}
              {deliveryType === 'private' && showButton ? (
                <Button
                  label="配送情報登録"
                  onClick={handlerClickDeliveryStoreRegister}
                  disabled={ordered}
                />
              ) : (<></>)}
            </div>
          </div>

          <div className="print_sidebar__contents__item item_status">
            <div className="item_label">
              ステータス
            </div>
            <div className={`item_body labeled_icon_hr${isLaboOrderRetry.current ? ' error' : ''}`}>
              {isLaboOrderRetry.current ?
                <img src={warningIcon} alt="" /> :
                <ColorIcon color={statusName} />
              }
              {
                isLaboOrderRetry.current ? '送信エラー' :
                statusName
              }
            </div>
          </div>
          <div className={`print_sidebar__contents__item item_customer`}>
            <div className="item_label">
              お客様メモ(DP袋番号など)
            </div>
            <div className={`item_body`}>
              <Input
                value={memo}
                onChange={(e) => handlerChangeCustomerMemo(e.target.value)}
                onBlur={(e) => handlerBlurCustomerMemo()}
                maxLength={30}
                disabled={ordered}
              />
            </div>
          </div>
          <div className={`print_sidebar__contents__item item_customer`}>
            <div className="item_label">
              出荷に関する特別な指示
            </div>
            <div className={`item_body`}>
              <Radiobutton
                checkState={checkOrderMemo ? '1' : '0'}
                label="特になし"
                value="0"
                onChange={() => handlerChangeCheckOrderMemo(false)}
                isStop
                disabled={ordered}
              />
              <Radiobutton
                checkState={checkOrderMemo ? '1' : '0'}
                label="コメントを追記"
                value="1"
                onChange={() => handlerChangeCheckOrderMemo(true)}
                isStop
                disabled={ordered}
              />
            </div>
          </div>
          <div className={`print_sidebar__contents__item ${checkOrderMemo ? 'item_memo' : ''}`}>
            <div className="item_body">
              {checkOrderMemo && (
                <TextArea
                  value={orderMemo}
                  onChange={(e) => handlerChangeOrderMemo(e.target.value)}
                  onBlur={(e) => handlerBlurOrderMemo(e.target.value)}
                  disabled={ordered}
                  limit={50}
                />
              )}
              <div className={`item_warning ${!checkOrderMemo ? 'not_memo' : ''}`}>
                ※同梱発送の依頼はお受けできません
              </div>
              <div className="item_link_wrapper">
                <span>→</span>
                <a
                  href={webPagePath.combinedShippingNotAllowed}
                  className="item_link"
                  onClick={handlerClickCombinedShippingLink}
                >
                  詳しい説明はこちら
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {registeringCustomerName || updatingDesignation ? (<LoadingPopup label="データを更新中です..." />) : (<></>)} */}
      {disableBg ? <div className="print_sidebar__disable_bg" /> : (<></>)}
    </>
  );
};
